export function init( node ) {

	const nextBlock  = node.nextElementSibling;

	if ( ! node ) {
		return;
	}

	let blockStyle = nextBlock.currentStyle || window.getComputedStyle(nextBlock);
	//calculate height of next element
	let blockHeight = parseInt(blockStyle.height);

	//gutterHeight should equal double the padding of the nextBlock if padding exists OR set to 3.5rem - this is double the gutter
	let gutterHeight;

	//use gutter css variable if padding doesn't exist on element
	const defaultGutter = parseFloat(window.getComputedStyle(document.body).getPropertyValue('--wp--custom--gutter')) * parseFloat(window.getComputedStyle(document.documentElement).fontSize);
	let topPadding = parseInt(blockStyle.paddingTop);
	let bottomPadding = parseInt(blockStyle.paddingBottom);

	if(topPadding > 0 || bottomPadding > 0) {
		gutterHeight = topPadding + bottomPadding;
	} else {
		gutterHeight = defaultGutter;
	}

	let isGreater768 = document.body.clientWidth >= 768;
	const matchMedia = window.matchMedia("(min-width: 768px)");

	matchMedia.addEventListener('change', ()=> {
		isGreater768 = document.body.clientWidth >= 768;
		blockSettings();
	});

	const blockSettings = () => {
		if(isGreater768) {
			//apply blockHeight value to node as padding minus gutterHeight
			node.style.paddingBottom = blockHeight - gutterHeight + 'px';

			//apply blockHeight value to nextBlock as negative margin minus gutterHeight
			nextBlock.style.marginTop = ((blockHeight - gutterHeight)*-1) + 'px';

			//add gutterHeight margin bottom to nextBlock
			nextBlock.style.marginBottom = (gutterHeight * -1) + 'px';
		} else {
			node.removeAttribute('style');
			nextBlock.removeAttribute('style');
		}
	}

	blockSettings();

	return node;

}


export const instances = Array.from( document.querySelectorAll( '.split-header.has-include-next-block' ) ).map( init );
